<template>
    <div class="logins">
      <div class="login-imgs">
        <img src="../../assets/img/login.png" alt="">
      </div>
      <div class="login-main">
        <h2>运营管理后台</h2>
        <div class="firstlogin">
           <el-input size="medium" @input="iptchanges" placeholder="请输入用户名"  prefix-icon="el-icon-s-custom" v-model="username">
           </el-input>
        </div>
        <div class="firstlogin firstlogin1">
           <el-input size="medium" placeholder="请输入密码" show-password  prefix-icon="el-icon-lock" @input="iptchangepass" v-model="pass">
           </el-input>
        </div>
        <div class="threelogin">
           <div class="threelogin-left">
                 <el-input size="medium" placeholder="请输入验证码"  prefix-icon="el-icon-lock" v-model="num" @input="iptchangeyan">
                </el-input>
            </div> 
            <div class="threelogin-right" @click="dianji">
              <img :src="urlimg" alt="">
            </div>
        </div>
        <p class="neirongcuoru">
           <span>{{texts}}</span>
          <span style="color:#fff" @click="zhaohui">找回密码</span>
        </p>
        <div class="firstlogin" @click="logins">
            <el-button type="primary">登录</el-button>
        </div>
      </div>
      <!-- <p class="ptext">© 2009-2019 Aliyun.com 版权所有 ICP证：浙B2-20080101</p> -->
      <findepasss v-if="showmima" @sendmsg="senclones"></findepasss>
    </div>
</template>
<script>
export default {
    components:{
        findepasss: resolve => {
         require(["./findpass.vue"], resolve);
         },  
     },
    data(){
        return{
          imgUrl: this.$store.state.img_url,  
          url:this.$store.state.p_url,
          urlimg: '',
          username:'',
          pass:'',
          num:'',
          imgss:'',
          texts:'',
          showmima:false
        }
    },
    methods:{
        dianji(){
               var ishttps = 'https:' == document.location.protocol ? true: false
                let url=this.url.split(':')
                let mainurl=''
                if(ishttps){
                    mainurl='https:'+url[1]
                }else{
                    mainurl='http:'+url[1]
                }
              this.urlimg=mainurl+'service/tool/captcha?num='+Math.random([1,10])
        },
        logins(){
                let that=this
               var ishttps = 'https:' == document.location.protocol ? true: false
                let url=this.url.split(':')
                let mainurl=''
                if(ishttps){
                    mainurl='https:'+url[1]
                }else{
                    mainurl='http:'+url[1]
                }
           if(that.username!=''){
               if(that.pass!=''){
                  if(that.num!=''){
                     console.log(this.url+"service/account/login");
                     that.$axios.post(url[1]+"service/account/login",{
                         username:that.username,
                          password:that.pass,
                          captcha:that.num
                     }).then(res=>{
                         if(res.data.code==200||res.data.code=='200'){
                               window.sessionStorage.setItem('name',res.data.data.name)
                               window.sessionStorage.setItem('admin',res.data.data.admin)
                               window.sessionStorage.setItem('appid',res.data.data.appid)
                               window.sessionStorage.setItem('root_id',res.data.data.id)
							  // console.log(admin);
							  this.$axios.defaults.headers.common['admin'] = res.data.data.admin;
							 this.$axios.defaults.headers.common['appid'] = res.data.data.appid;
                              this.$router.push({
                                    path: '/',
                                })
                         }else{
                              this.texts=res.data.msg
                         }
                         this.dianji() 
                     }).catch(function (err) {
                            console.log(err)
                        })   
                  }else{
                     this.texts='请输入您的验证码'   
                  }  
               }else{
                 this.texts='请输入您的密码'  
               }
           }else{
              this.texts='请输入您的用户名'  
           }
        },
        iptchanges(value){
           if(value!=''){
              this.texts=''  
           }  
        },
        iptchangepass(value){
            if(value!=''){
              this.texts=''  
           }  
        },
        iptchangeyan(value){
             if(value!=''){
              this.texts=''  
           } 
        },
        zhaohui(){
          this.showmima=true
        },
        senclones(){
            this.showmima=false
        }


    },
    mounted(){
        $('title').html('登录')
          var ishttps = 'https:' == document.location.protocol ? true: false
            let url=this.url.split(':')
            let mainurl=''
            if(ishttps){
                mainurl='https:'+url[1]
            }else{
                mainurl='http:'+url[1]
            }
          this.urlimg=mainurl+'service/tool/captcha?num='+Math.random([1,10])
    },
}
</script>
<style scoped>
.logins{
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    position: relative;
}
.login-imgs img{
   position: absolute;
   left: 0;
   top: 0;
   width: 100vw;
   height: 100vh;
   display: block;  
}
.login-main{
    width: 364px;
    height: 413px;
    background-color: #429ADA;
    position: absolute;
    left: 40%;
    top: 250px;
    right: 50%;
    border-radius:4px;
    cursor: pointer;
}
.login-main h2{
    width: 364px;
    height: 92px;
    font-size: 20px;
    font-weight:bold;
    color: #ffffff;
    z-index: 5;
    display: flex;
    justify-content: center;
    align-content: center;
    line-height: 92px;
    letter-spacing:3px
}
.firstlogin{
    width: 312px;
    height: 50px;
    margin: 0 auto;
    font-size: 14px;
}
>>>.el-input--medium .el-input__inner {
    height: 50px!important;
    line-height: 50px!important;
}
.firstlogin1{
    margin-top:20px
}
.firstlogin button{
     width: 312px;
     height: 50px;
     margin-top:20px;
}
.threelogin{
    width: 312px;
    height: 50px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
}
.threelogin-left{
    width: 189px;
    height: 50px;
}
.threelogin-right{
    width: 117px;
    height: 50px;
    background-color: #ffffff;
}
.threelogin-right img{
    width: 117px;
    height: 50px;
    display: block;
    border-radius: 4px;
}
.ptext{
    width: 394px;
    position: absolute;
    bottom: 32px;
    font-size: 14px;
    color: #ffffff;
    left: 40%;
}
.neirongcuoru{
   width: 312px;
    height: 20px;
    text-align: center;
    line-height: 40px;
    font-size: 12px;
    color: #f00;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}
.neirongcuoru span:nth-of-type(2){
  width: 100px;
  height: 40px;
  display: block;
  text-align: right;
}

</style>


// WEBPACK FOOTER //
// src/components/comment/login.vue